import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    formControlAutoComplete: {
        minWidth: "100%",
        margin: "10px"
    },
    formControl: {
        minWidth: "100%",
        margin: "10px",
    },
    input: {
        padding: "5px",
    },
    centerTypographyRoot: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    select: {
        color: "white",
    },
    label:{color: "white"},
    icon: { color: "white" },
    selectBorder: {
        textAlignLast:"left",
        "&:before": {
            borderColor: "white"
        }
    },
    highlightCell: { backgroundColor: "rgb(250, 250, 235)" },
    paddingPaper:{
        paddingBottom: theme.spacing(2),
        minHeight:"100%",
        height:"100%"
    },
    heightPaper:{
        minHeight:"100%",
        height:"100%"
    },
    heightScrolledTableTop:{
        height: "400px",
    },
    heightScrolledTableBottom:{
        maxHeight: "500px",
    }
}), {index: 1});